/**
 * 10.9BF — FÚRIA (Thiago: "vida baixa ele bate mais ainda"). Abaixo de `below` da vida, o dano
 * do boss sobe LINEARMENTE até `maxMult` em 0% — vale pra TODOS os bosses (VoidAlpha, RiftSeer,
 * Colossus) porque cada um passa a ler `dmgMult` por este multiplicador.
 */
import { GameConfig } from "../config/GameConfig";

export function furyMult(hpFraction: number): number {
  const c = GameConfig.boss.fury;
  if (hpFraction >= c.below) return 1;
  const t = 1 - Math.max(0, hpFraction) / c.below; // 0 no limiar → 1 em 0% de vida
  return 1 + (c.maxMult - 1) * t;
}

export function inFury(hpFraction: number): boolean {
  return hpFraction < GameConfig.boss.fury.below;
}
